const getEnvironment = () => {
  // Production domains
  if (
    window.location.hostname === "app.samanthaai.co" ||
    window.location.hostname === "samanthaai.co" ||
    window.location.hostname === "sapienslab.net" ||
    window.location.hostname === "d22787s4qdjksp.cloudfront.net"
  ) {
    return "production";
  }

  // Staging domains
  if (
    window.location.hostname === "staging.samanthaai.co" ||
    window.location.hostname === "d3tgcrhj4v7nz.cloudfront.net"
  ) {
    return "staging";
  }

  // Local development and all other cases default to production
  return "production";
};

const CONFIG = {
  staging: {
    websocket: "wss://1vdu6i2qwa.execute-api.us-east-1.amazonaws.com/prod", // Make sure this matches the stage name in CDK
    api: {
      chat: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod",
      products: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod",
      retrieveMessages:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/retrieve-messages",
      threadManagement:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/thread-management",
      upload:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/upload",
      todos:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/get-todos",
      // Character management endpoints (through middleware)
      characters: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/character-management",
      // Public character discovery board endpoint (no auth required)
      publicCharacters: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/public-characters",
      // Media usage tracking endpoint (through middleware)
      mediaUsage: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/media-usage",
    },
  },
  production: {
    websocket: "wss://1vdu6i2qwa.execute-api.us-east-1.amazonaws.com/prod", // Make sure this matches the stage name in CDK
    api: {
      chat: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod",
      products: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod",
      retrieveMessages:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/retrieve-messages",
      threadManagement:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/thread-management",
      upload:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/upload",
      todos:
        "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/get-todos",
      // Character management endpoints (through middleware)
      characters: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/character-management",
      // Public character discovery board endpoint (no auth required)
      publicCharacters: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/public-characters",
      // Media usage tracking endpoint (through middleware)
      mediaUsage: "https://f92gtnao40.execute-api.us-east-1.amazonaws.com/prod/media-usage",
    },
  },
};

export const endpoints = CONFIG[getEnvironment()];

// Export the current environment for debugging
export const currentEnvironment = getEnvironment();
